/*
* For Development uncomment the below export 
*/
// export const BASE_URL = "http://localhost:8080"

/*
* For Production uncomment the below export
*/

export const BASE_URL = process.env.VITE_BACKEND_URL || "https://rentlydashboard.com"; // Updated to use the HTTPS URL
